import React from "react";
import { useLocation, Outlet, Link, useOutletContext } from "react-router-dom";

const MainNegotiations = () => {
  const path = useLocation().pathname;
  const outletContext = useOutletContext();

  const isNegotiationPath = path.includes("/nova-negociacao") || path.includes("/editar-negociacao");

  return (
    <>
      {!isNegotiationPath && (
        <section className="container prices-table-filter no-bottom">
          <div className="filter-tabs no-bottom">
            <Link
              to="/tabela-preco"
              className={`tab ${path === "/tabela-preco" || path === "/tabela-preco/" ? "active" : ""}`}
            >
              Todas as negociações
            </Link>

            <Link
              to="/tabela-preco/proximas-do-vencimento"
              className={`tab ${path.includes("/tabela-preco/proximas-do-vencimento") ? "active" : ""}`}
              data-test-id="link-proximas-do-vencimento"
            >
              Próximas do Vencimento
            </Link>
          </div>
        </section>
      )}

      <div className="tab-content">
        <Outlet context={outletContext} />
      </div>
    </>
  );
};

export default MainNegotiations;
